<mat-card>
  <app-card-header [title]="title" [icon]="icon" />

  <mat-card-content class="card-content">
    <ng-container *ngIf="messages && messages.length">
      <swiper-container space-between="16" pagination="true" pagination-clickable="true" [breakpoints]="breakpoints">
        <swiper-slide *ngFor="let message of messages">
          <app-recent-message [message]="message" />
        </swiper-slide>
      </swiper-container>
    </ng-container>
    <ng-container *ngIf="!messages || messages.length == 0">
      <span class="no-items">{{noMessagesText}}</span>
    </ng-container>
  </mat-card-content>
</mat-card>
